import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getCompleteSizes } from '@cian/adfox-component';
import { Component } from 'react';
import { MortgageAnnotations } from '../../MortgageAnnotations';
import { Ticker } from '../../Ticker';
import style from './ParallaxGeneralTemplate.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BACKGROUND_MAX_HEIGHT = 740;
export class ParallaxGeneralTemplate extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "container", null);
    _defineProperty(this, "animatedBg", null);
    _defineProperty(this, "topPosition", void 0);
    _defineProperty(this, "bottomPosition", void 0);
    _defineProperty(this, "containerHeight", void 0);
    _defineProperty(this, "scrollHandler", void 0);
    _defineProperty(this, "resizeHandler", void 0);
  }
  componentDidMount() {
    if (this.container) {
      let shouldChange = false;
      this.containerHeight = this.container.offsetHeight;
      const scrollHandler = () => {
        if (!shouldChange) {
          return;
        }
        shouldChange = false;
        if (window.scrollY > this.topPosition && window.scrollY < this.bottomPosition && this.animatedBg) {
          const bgOffset = (window.scrollY - this.topPosition) / (window.innerHeight + BACKGROUND_MAX_HEIGHT);
          const translate = bgOffset * (this.containerHeight - BACKGROUND_MAX_HEIGHT);
          this.animatedBg.style.transform = "translateY(".concat(Math.round(translate), "px)");
        }
      };
      const img = new Image();
      this.scrollHandler = () => {
        shouldChange = true;
        requestAnimationFrame(scrollHandler);
      };
      this.resizeHandler = () => {
        this.getParams();
        requestAnimationFrame(scrollHandler);
      };
      img.onload = () => {
        this.getParams();
        this.setState({
          bgPosition: window.innerHeight - BACKGROUND_MAX_HEIGHT
        });
        window.addEventListener('scroll', this.scrollHandler);
        window.addEventListener('resize', this.resizeHandler);
      };
      img.src = this.props.context.mobBackgroundImageUrl || this.props.context.backgroundImageUrl;
    }
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);
  }
  render() {
    const {
      context: {
        annotation,
        url,
        label,
        mortgageWarning,
        mortgageTermsWarning
      },
      height,
      width,
      deviceType
    } = this.props;
    return /*#__PURE__*/_jsxs("a", {
      className: style['link-container'],
      "data-name": "ParallaxGeneralTemplate",
      href: url,
      rel: "noreferrer noopener nofollow",
      style: getCompleteSizes({
        height,
        width
      }),
      target: "_blank",
      children: [/*#__PURE__*/_jsxs("div", {
        className: style['container'],
        ref: container => this.container = container,
        children: [/*#__PURE__*/_jsx("div", {
          className: style['background'],
          ref: animatedBg => this.animatedBg = animatedBg,
          style: {
            backgroundImage: this.backgroundImageUrl
          }
        }), /*#__PURE__*/_jsx("div", {
          className: style['image'],
          style: {
            backgroundImage: this.textImageUrl
          }
        }), annotation && /*#__PURE__*/_jsx("div", {
          className: style['annotation'],
          children: /*#__PURE__*/_jsx(Ticker, {
            text: annotation,
            theme: "dark-background"
          })
        }), label && /*#__PURE__*/_jsx("span", {
          className: style['label'],
          children: label
        })]
      }), (mortgageWarning || mortgageTermsWarning) && /*#__PURE__*/_jsx("div", {
        className: style['mortgage-annotations-wrapper'],
        children: /*#__PURE__*/_jsx(MortgageAnnotations, {
          height: height,
          mortgageTermsWarning: mortgageTermsWarning,
          mortgageWarning: mortgageWarning,
          splitMortgageTermsWarning: deviceType === 'desktop' ? 'auto' : 'force'
        })
      })]
    });
  }
  get backgroundImageUrl() {
    const {
      context: {
        backgroundImageUrl,
        mobBackgroundImageUrl
      },
      deviceType
    } = this.props;
    const imageUrl = deviceType === 'desktop' ? backgroundImageUrl || mobBackgroundImageUrl : mobBackgroundImageUrl || backgroundImageUrl;
    return "url(".concat(imageUrl, ")");
  }
  get textImageUrl() {
    const {
      context: {
        textImageUrl,
        mobTextImageUrl
      },
      deviceType
    } = this.props;
    const imageUrl = deviceType === 'desktop' ? textImageUrl || mobTextImageUrl : mobTextImageUrl || textImageUrl;
    return "url(".concat(imageUrl, ")");
  }
  getParams() {
    if (this.container) {
      this.topPosition = this.container.offsetTop - window.innerHeight;
      this.bottomPosition = this.topPosition + this.container.offsetHeight + window.innerHeight;
    }
  }
}